import React from 'react';

interface LessCriticalProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const LessCritical: React.FC<LessCriticalProps> = (props) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.5 15C27.5 8.09644 21.9036 2.5 15 2.5C8.09644 2.5 2.5 8.09644 2.5 15C2.5 21.9036 8.09644 27.5 15 27.5C21.9036 27.5 27.5 21.9036 27.5 15ZM15 7.8125C15.5178 7.8125 15.9375 8.23223 15.9375 8.75V16.25C15.9375 16.7678 15.5178 17.1875 15 17.1875C14.4822 17.1875 14.0625 16.7678 14.0625 16.25V8.75C14.0625 8.23223 14.4822 7.8125 15 7.8125ZM15 21.25C15.6904 21.25 16.25 20.6904 16.25 20C16.25 19.3096 15.6904 18.75 15 18.75C14.3096 18.75 13.75 19.3096 13.75 20C13.75 20.6904 14.3096 21.25 15 21.25Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default LessCritical;
